import { DEFAULT_ATTRIBUTES, UID } from 'shared/api/query/constants';
import {
  goal as goalConfig,
  gridPage as gridPageConfig,
  planning as planningConfig,
  printable as printableConfig,
  savedView as savedViewConfig,
  space as spaceConfig,
  storageObject as storageObjectConfig,
} from 'shared/api/query/configs.json';
import { storageObjectEdges } from '@/api/query/nebula/storage-object';

export const printableChildren = [
  ...DEFAULT_ATTRIBUTES,
  { attr: printableConfig.edges.width },
  { attr: printableConfig.edges.status },
  { attr: printableConfig.edges.localStorage },
  { attr: printableConfig.edges.page },
  { attr: printableConfig.edges.exportFormat },
  {
    attr: printableConfig.edges.storageObject,
    model: storageObjectConfig.model,
    children: storageObjectEdges,
  },
  {
    attr: printableConfig.edges.gridPage,
    model: gridPageConfig.model,
    children: [{ attr: UID }],
  },
  {
    attr: printableConfig.edges.savedView,
    model: savedViewConfig.model,
    children: [{ attr: UID }],
  },
  {
    attr: printableConfig.edges.goals,
    model: goalConfig.model,
    default: [],
    children: [{ attr: UID }],
  },
  {
    attr: printableConfig.edges.space,
    model: spaceConfig.model,
    children: [{ attr: UID }],
  },
  {
    attr: printableConfig.edges.planning,
    model: planningConfig.model,
    children: [{ attr: UID }],
  },
];
